import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getListParentFilter } from '../../../api/entity';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { editEntityField, setSelectedFieldSet } from '../../actions/entity-designer.actions';
import { RESOLVER_TYPE_LISTS } from '../../constants/entity-designer.constants';
import {
  getEntityInfo,
  getFieldSetListItems,
  getSelectedFieldSet,
  getSelectedFieldSetInfo,
} from '../../selectors/entity-designer.selectors';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20,
  },
  label: {
    marginTop: 3,
    marginLeft: 10,
  },
  select: {
    width: 380,
    marginLeft: 20,
    marginTop: '8px !important',
  },
});

const FieldSetDropdown = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const selectedFieldSet = useSelector(getSelectedFieldSet);
  const fieldSetListItems = useSelector(getFieldSetListItems);
  const fieldByFieldSet = useSelector(getSelectedFieldSetInfo);
  const entityInfo = useSelector(getEntityInfo);

  const [listParentFilterOptions, setListPatentFilterOptions] = useState([]);

  const onChange = ({ target: { value } }) => {
    dispatch(setSelectedFieldSet(value));
  };

  useEffect(() => {
    if (selectedFieldSet?.length && fieldByFieldSet.ResolverType === RESOLVER_TYPE_LISTS) {
      const fetchListOptions = async () => {
        const { listParentFilter } = await getListParentFilter({
          entityName: entityInfo.EntityName,
          currentColumnName: fieldByFieldSet.FieldName,
        });
        setListPatentFilterOptions(listParentFilter);
      };
      fetchListOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFieldSet, fieldByFieldSet]);

  return (
    <div className={classes.root}>
      <Typography className={classes.label}>{translateString('Field Set')}</Typography>
      <Select className={classes.select} value={selectedFieldSet} onChange={onChange} size="small">
        {fieldSetListItems.map((item, index) => (
          <MenuItem key={item.value + index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {fieldByFieldSet.ResolverType === RESOLVER_TYPE_LISTS && (
        <>
          <Typography className={classes.label}>{translateString('List Parent Filter')}</Typography>
          <Select
            className={classes.select}
            value={fieldByFieldSet?.ResolverTypeListParent || ''}
            onChange={({ target: { value } }) =>
              dispatch(
                editEntityField({
                  rowId: fieldByFieldSet.rowId,
                  key: 'ResolverTypeListParent',
                  value: value || null,
                })
              )
            }
            size="small"
          >
            {listParentFilterOptions?.map((item, index) => (
              <MenuItem key={item.Value + index} value={item.Value}>
                {item.Text}
              </MenuItem>
            ))}
          </Select>
        </>
      )}
    </div>
  );
};

export default FieldSetDropdown;
